import Storage from './Storage';

const setMinHeight = () => {
    const footer = document.getElementById('site-footer');
    if ( ! footer ) {
        document.body.style.removeProperty('--site-fh');
        return;
    }

    if( document.body.classList.contains('gk-backstop') || -1 === window.location.href.indexOf('gk_backstop=true') ) {
        document.documentElement.style.setProperty('--site-fh', `${footer.offsetHeight}px`);
        return;
    }

    const storage = new Storage();

    const windowWidth = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    const windowHeight = window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;

    let footerHeight = storage.get(`fh__${windowWidth}x${windowHeight}`);

    if (!footerHeight) {
        footerHeight = footer.offsetHeight;
        storage.set(`fh__${windowWidth}x${windowHeight}`, footerHeight);
    }

    document.documentElement.style.setProperty('--site-fh', `${footerHeight}px`);
}

export default setMinHeight;
